module.exports = __webpack_public_path__ + "static/media/REST4.e3beff20.png";